import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { RequestVerifyService } from '../../services/request-verify.service';
import { ReqVerificationStage } from '../../model/req-verification-stage.model';
import { TargetEvaluator } from '../enums/target-evaluator.enum';
import { CplUserRequest } from 'src/app/model/cpl-user-request.model';

@Component({
    templateUrl: './sm-reassign-stage-modal.component.html'
})
export class ReassignStageModalComponent implements OnInit {
    @Input() userRequest: CplUserRequest;

    form: UntypedFormGroup;
    verificationStage: ReqVerificationStage;

    constructor(
        public activeModal: NgbActiveModal, 
        private formBuilder: UntypedFormBuilder,
        private requestVerifyService: RequestVerifyService
    ) { }

    TargetEvaluator = TargetEvaluator;


    ngOnInit() {
         this.verificationStage = this.userRequest.VerificationStages.find(stage => stage.StageID == this.userRequest.VerificationStage.StageID);

        this.form = this.formBuilder.group({
            SelectedUser: [this.verificationStage.SelectedUserId ?? TargetEvaluator.ALL, []]
        });
    }

    ok({ value }: { value: { SelectedUser: string } }) {
        const previousApprover = this.verificationStage.SelectedUserId;
        this.verificationStage.SelectedUserId = value.SelectedUser;
        this.requestVerifyService.reassign(this.userRequest)
            .subscribe(() => {
                this.activeModal.close(true);
            }, (error) => {
                console.log(error);
                this.verificationStage.SelectedUserId = previousApprover;
                this.activeModal.dismiss();
            });
    }

    cancel() {
        this.activeModal.dismiss();
    }
}
